(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection-01"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('section.featured-collections').forEach(function (sectionEl) {
    var wrap = sectionEl.querySelector('.collections-wrap');
    if (!wrap) return;

    var grid = wrap.querySelector('.collections-grid');
    if (!grid || grid.getAttribute('data-mobile-swipe') !== 'true') return;

    var prev = wrap.querySelector('.ms-prev');
    var next = wrap.querySelector('.ms-next');
    if (!prev || !next) return;

    function cardWidth() {
      var card = grid.querySelector('.collection-item');
      if (!card) return 0;
      var rect = card.getBoundingClientRect();
      var style = window.getComputedStyle(card);
      var ml = parseFloat(style.marginLeft) || 0;
      var mr = parseFloat(style.marginRight) || 0;
      return rect.width + ml + mr + 12; // include 12px gap
    }

    function scrollByCard(dir) {
      grid.scrollBy({ left: dir * cardWidth(), behavior: 'smooth' });
    }

    function updateArrows() {
      var isMobile = window.matchMedia('(max-width: 768px)').matches;
      var arrows = wrap.querySelector('.mobile-swipe-arrows');
      if (!arrows) return;
      arrows.style.display = isMobile ? 'block' : 'none';

      var maxScroll = grid.scrollWidth - grid.clientWidth - 1;
      prev.disabled = (grid.scrollLeft <= 0);
      next.disabled = (grid.scrollLeft >= maxScroll);
    }

    prev.addEventListener('click', function(){ scrollByCard(-1); });
    next.addEventListener('click', function(){ scrollByCard(1); });

    grid.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', function(){ setTimeout(updateArrows, 120); });

    setTimeout(updateArrows, 50);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
class ProductCarousel {
  constructor(container) {
    this.container = container;
    this.track = container.querySelector('.carousel-track');
    this.slides = container.querySelectorAll('.product-slide');
    this.prevButton = container.querySelector('.carousel-prev');
    this.nextButton = container.querySelector('.carousel-next');

    this.slidesPerView = window.innerWidth <= 768 ? 2 : 
                        parseInt(container.dataset.slidesPerView || 4);
    this.slideGap = parseInt(container.dataset.slideGap || 20);
    this.currentIndex = 0;
    this.totalSlides = this.slides.length;
    
    this.touchStartX = 0;
    this.touchEndX = 0;
    this.isDragging = false;

    this.init();
  }

  init() {
    if (this.totalSlides <= this.slidesPerView) {
      this.prevButton.style.display = 'none';
      this.nextButton.style.display = 'none';
      return;
    }

    this.setupInfiniteScroll();
    this.bindEvents();
    this.updateButtonStates();
  }

  setupInfiniteScroll() {
    const slidesToClone = Math.min(this.slidesPerView, this.totalSlides);
    
    for (let i = 0; i < slidesToClone; i++) {
      const firstClone = this.slides[i].cloneNode(true);
      const lastClone = this.slides[this.totalSlides - 1 - i].cloneNode(true);
      this.track.appendChild(firstClone);
      this.track.insertBefore(lastClone, this.track.firstChild);
    }

    this.slides = this.container.querySelectorAll('.product-slide');
    this.totalSlides = this.slides.length;
    
    this.currentIndex = slidesToClone;
    this.updatePosition(false);
  }

  bindEvents() {
    this.prevButton.addEventListener('click', () => this.prev());
    this.nextButton.addEventListener('click', () => this.next());
    this.track.addEventListener('transitionend', () => this.handleTransitionEnd());
    this.track.addEventListener('touchstart', (e) => this.handleTouchStart(e), { passive: true });
    this.track.addEventListener('touchmove', (e) => this.handleTouchMove(e), { passive: false });
    this.track.addEventListener('touchend', (e) => this.handleTouchEnd(e));

    window.addEventListener('resize', () => {
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => this.handleResize(), 200);
    });
  }

  handleTouchStart(e) {
    this.touchStartX = e.touches[0].clientX;
    this.isDragging = true;
    this.track.style.transition = 'none';
  }

  handleTouchMove(e) {
    if (!this.isDragging) return;
    
    this.touchEndX = e.touches[0].clientX;
    const diff = this.touchStartX - this.touchEndX;
    const slideWidth = this.slides[0].offsetWidth + this.slideGap;
    const currentOffset = -this.currentIndex * slideWidth;
    
    this.track.style.transform = `translateX(${currentOffset - diff}px)`;
    e.preventDefault();
  }

  handleTouchEnd(e) {
    if (!this.isDragging) return;
    
    const diff = this.touchStartX - this.touchEndX;
    const threshold = 50;

    if (Math.abs(diff) > threshold) {
      if (diff > 0) {
        this.next();
      } else {
        this.prev();
      }
    } else {
      this.updatePosition();
    }

    this.isDragging = false;
    this.track.style.transition = 'transform 0.5s ease';
  }

  handleResize() {
    const oldSlidesPerView = this.slidesPerView;
    this.slidesPerView = window.innerWidth <= 768 ? 2 : 
                        parseInt(this.container.dataset.slidesPerView || 4);

    if (oldSlidesPerView !== this.slidesPerView) {
      this.updatePosition(false);
      this.updateButtonStates();
    }
  }

  prev() {
    if (this.isAnimating) return;
    this.currentIndex--;
    this.updatePosition();
  }

  next() {
    if (this.isAnimating) return;
    this.currentIndex++;
    this.updatePosition();
  }

  updatePosition(animate = true) {
    this.isAnimating = animate;
    
    const slideWidth = this.slides[0].offsetWidth + this.slideGap;
    const offset = -this.currentIndex * slideWidth;

    this.track.style.transition = animate ? 'transform 0.5s ease' : 'none';
    this.track.style.transform = `translateX(${offset}px)`;

    if (!animate) {
      this.track.offsetHeight;
      this.track.style.transition = 'transform 0.5s ease';
    }

    this.updateButtonStates();
  }

  handleTransitionEnd() {
    this.isAnimating = false;
    
    const totalSlidesBeforeClones = this.totalSlides - (this.slidesPerView * 2);
    
    if (this.currentIndex <= this.slidesPerView - 1) {
      this.currentIndex = totalSlidesBeforeClones + this.slidesPerView - 1;
      this.updatePosition(false);
    } else if (this.currentIndex >= totalSlidesBeforeClones + this.slidesPerView) {
      this.currentIndex = this.slidesPerView;
      this.updatePosition(false);
    }
  }

  updateButtonStates() {
    const isAtStart = this.currentIndex <= 0;
    const isAtEnd = this.currentIndex >= this.totalSlides - this.slidesPerView;

    this.prevButton.disabled = isAtStart;
    this.nextButton.disabled = isAtEnd;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const carousels = document.querySelectorAll('[data-section-type="featured-products"]');
  carousels.forEach(carousel => new ProductCarousel(carousel));
});

  } catch(e) { console.error(e); }
})();
})();
